var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"bar_code_echart",staticClass:"bar-code-chart"})
}
var staticRenderFns = []

export { render, staticRenderFns }